import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

interface EmspBoChargingSessionListLocationNameCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['locationName']
  > {}

export const EmspBoChargingSessionListLocationNameCell = ({
  getValue,
  row,
}: EmspBoChargingSessionListLocationNameCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  const label = getValue() ?? row.original.locationCity ?? '—';

  if (!row.original.locationId) {
    return <Text truncate>{label}</Text>;
  }

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.LOCATION.DETAILS, {
            id: row.original.locationId,
          }),
        )
      }
      fullWidth>
      <Text truncate>{label}</Text>
    </Link>
  );
};
